const HniSection = () => {
  return (
    <section class="about about--style1 bg-color xts-section">
        <div class="container">
            <div class="about__wrapper">
                <div class="row gx-5 gy-4 gy-sm-0 align-items-center">
                    
                    <div class="col-lg-6">
                        <div class="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                            <div class="about__thumb-inner">
                                <div class="about__thumb-image floating-content">
                                    <img class="dark" src="assets/images/new/uhni.jpg" alt="High Net-Worth Individual"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="about__content" data-aos="fade-left" data-aos-duration="800">
                            <div class="about__content-inner">
                                <h2 class="meet-oppurtanity">Ultra High <span class="style2">Net-Worth Individuals</span> (UHNIs)</h2>
                                <p>
                                    Ultra-High-Net-Worth clients and family offices gain bespoke portfolio management, concierge support, and premium wealth strategies tailored to complex financial goals.
                                </p>
                                <p>
                                    UHNIs benefit from premium investment opportunities, tailored wealth management, and dedicated IPO allocations due to their higher financial capacity and investment sophistication.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 mt-30">
                        <div class="benefits-section" data-aos="fade-up" data-aos-duration="800">
                            <div class="benefits-inner">
                                <h3 class="benefits-title">Key Characteristics</h3>

                                <div class="benefits-list">
                                    <div class="benefit-item" data-aos="fade-left" data-aos-duration="800">
                                        <div class="benefit-icon">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                        <div class="benefit-content">
                                            <h5 class="benefit-heading">Wealth Threshold</h5>
                                            <p class="benefit-text">Generally possess investable assets exceeding ₹5 crore in India.</p>
                                        </div>
                                    </div>

                                    <div class="benefit-item" data-aos="fade-left" data-aos-duration="800">
                                        <div class="benefit-icon">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                        <div class="benefit-content">
                                            <h5 class="benefit-heading">IPO Investment</h5>
                                            <p class="benefit-text">Defined by SEBI as investors applying for IPO shares above ₹2 lakh.</p>
                                        </div>
                                    </div>

                                    <div class="benefit-item" data-aos="fade-left" data-aos-duration="800">
                                        <div class="benefit-icon">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                        <div class="benefit-content">
                                            <h5 class="benefit-heading">Exclusive Benefits</h5>
                                            <p class="benefit-text">Dedicated IPO allocations, premium services, and custom strategies.</p>
                                        </div>
                                    </div>

                                    <div class="benefit-item" data-aos="fade-left" data-aos-duration="800">
                                        <div class="benefit-icon">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                        <div class="benefit-content">
                                            <h5 class="benefit-heading">Sub-Categories</h5>
                                            <p class="benefit-text">UHNIs are further divided into UHNIs, and UHNI based on wealth levels.</p>
                                        </div>
                                    </div>

                                    <div class="benefit-item" data-aos="fade-left" data-aos-duration="800">
                                        <div class="benefit-icon">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                        <div class="benefit-content">
                                            <h5 class="benefit-heading">Regulatory Definition</h5>
                                            <p class="benefit-text">SEBI regulations govern IPO participation under the NII category.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 mt-30">
                        <div class="about__content">
                            <div class="about__content-inner">
                                <h3 class="text-center" data-aos="fade-right" data-aos-duration="500">
                                    HNI Sub-Categories
                                </h3>

                                <div class="platform-features justify-content-evenly">
                                    <div class="feature-card" data-aos="fade-up" data-aos-duration="500">
                                        <div class="feature-icon">
                                            <i class="fas fa-user-tie"></i>
                                        </div>
                                        <div class="feature-title">HNIs</div>
                                        <div class="feature-desc">Up to ₹5 crore in investable assets.</div>
                                    </div>

                                    <div class="feature-card" data-aos="fade-up" data-aos-duration="500">
                                        <div class="feature-icon">
                                            <i class="fas fa-gem"></i>
                                        </div>
                                        <div class="feature-title">UHNIs</div>
                                        <div class="feature-desc">Exceeding ₹25 crore with diversified portfolios.</div>
                                    </div>
                                </div>

                                <div class="info-box mt-4">
                                    <h3 class="mb-3" data-aos="fade-right" data-aos-duration="800">IPO Allocation for HNIs</h3>
                                    <p data-aos="fade-left" data-aos-duration="500">
                                        In IPOs, HNIs belong to the Non-Institutional Investor (NII) category, applying for shares worth more than ₹2 lakh. They receive a fixed 15% allocation of the IPO offer, distinct from retail investors and Qualified Institutional Buyers (QIBs).
                                    </p>
                                </div>

                                <h3 class="mt-4 mb-3" data-aos="fade-right" data-aos-duration="800">
                                    Regulatory Framework
                                </h3>
                                <p class="mb-2" data-aos="fade-left" data-aos-duration="500">
                                    <b>SEBI Guidelines:</b> SEBI governs HNI IPO participation under the NII category.
                                </p>
                                <p class="mb-2" data-aos="fade-left" data-aos-duration="500">
                                    <b>Investment Limits:</b> Minimum IPO application above ₹2 lakh, no upper cap.
                                </p>
                                <p class="mb-2" data-aos="fade-left" data-aos-duration="500">
                                    <b>Documentation:</b> Enhanced KYC may be required for verification.
                                </p>

                                <table class="comparison-table" data-aos="fade-up" data-aos-duration="800">
                                    <thead>
                                        <tr>
                                            <th>Investor Category</th>
                                            <th>Investment Limit in IPO</th>
                                            <th>Allocation Percentage</th>
                                            <th>Documentation Required</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><b>Retail Investor</b></td>
                                            <td>Up to ₹2 lakh</td>
                                            <td>35% of offer</td>
                                            <td>Basic KYC</td>
                                        </tr>
                                        <tr>
                                            <td><b>HNI (NII)</b></td>
                                            <td>Above ₹2 lakh (no upper limit)</td>
                                            <td>15% of offer</td>
                                            <td>Enhanced KYC</td>
                                        </tr>
                                        <tr>
                                            <td><b>QIB</b></td>
                                            <td>No limit</td>
                                            <td>50% of offer</td>
                                            <td>Institutional documents</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

  );
};

export default HniSection;